export let loggerConfig = {
  isLogToConsole: true,
  isLogToServer: false,
  logToServerURL: "",
};

export const getLoggerConfig = () => loggerConfig;
export const setLoggerConfig = config => (loggerConfig = { ...loggerConfig, ...config });
